import moment from "moment";
import bizmsg from "bizmsg-alimtalk";


//type
export const ADD_CART = 'add_cart';
export const SEND_MSG = 'send_msg';
//action
export function AddCart(body){
    return{
        type: ADD_CART,
        payload: body
    }
}
export function SendMSG(body){
    const now = moment().format('YYYY/MM/DD');
    const boot = async ()=>{
        bizmsg.init('jejuang','3416378fc1551b7f403052829a5cad98d68143dc');
    }
    console.log(body)
    boot().then(()=>{
        bizmsg.sendMessage({
            msg: `보기 좋은 떡이 맛도 좋다! 제주앙!
${body.user_name} 고객님의 주문이 예약 신청되었습니다.

💎 주문 및 결제 내역
👉 입금 계좌 : 농협 3021702504341 (예금주 임창범)
👉 금액 : ${body.user_price}

☝예약 신청 후 2시간 이내 미입금 시 예약은 자동 취소됩니다🥲
☝입금자명과 주문자명이 다를 경우 제주앙에 문의 부탁드립니다!

💎 환불 규정
픽업일 기준 24시간 전까지 전액 환불
단, 픽업 당일 환불 불가

☎ ) 0507-1352-6572`,
            phn: body.phone,
            tmplId: 'post_reservation_cart',
        }).then(res => console.log("res:",res)).catch((err)=>console.log('err:',err));
    })

    return{
            type: SEND_MSG,
            payload: body
    }
}
//reducer
const reducer = (state={},action)=>{
    switch (action.type){
        case ADD_CART:
            return {
                ...state,
                add_cart: action.payload,
            };
        case SEND_MSG:
            return {
                ...state,
                send_msg: action.payload,
            }
        default:
            return state;
    }
};




export default reducer;
